import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/products/games/components/GameCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/rico-series/components/RicoGamesCards/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/rico-series/components/RicoMoviesSlider/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/app/[lang]/(web)/rico-series/styles.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/Layout/Footer/components/BecomePartner/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ar.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/en.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/es.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/fr.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/hi.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/pt.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ru.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/zh.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/Rico/design.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/Rico/integrate.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/Rico/meet-bg.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/Rico/responsive.png");
